import React from "react";
import {
  Box,
  Container,
  Heading,
  Text,
  UnorderedList,
  ListItem,
  Link,
  Button,
  Badge,
} from "@chakra-ui/react";

const Card = ({ title, accent, children }) => (
  <article
    className="break-inside-avoid inline-block w-full rounded-xl bg-black p-6 ring-1 ring-white/10 h-full flex flex-col"
    style={{ boxShadow: "0 0 40px rgba(94,0,255,.15)" }}
  >
    {/* accent bar */}
    <div
      style={{ background: accent ?? "var(--card-accent, #7ae0ff)" }}
      className="h-1.5 w-14 rounded-full mb-4"
      aria-hidden
    />
    <Heading as="h3" size="md" mb={3} color="white">
      {title}
    </Heading>
    <Box color="whiteAlpha.900" className="flex-1">{children}</Box>
  </article>
);

export default function ServicesWaterfall() {
  return (
    <Box as="section" id="services" py={{ base: 16, md: 24 }} bg="black" color="white">
      <Container maxW="container.lg">
        <Heading as="h2" size="xl" textAlign="center">
          Our Services
        </Heading>
        <Text mt={3} textAlign="center" color="whiteAlpha.800">
          Offensive Security and Governance, Risk &amp; Compliance delivered with clear outcomes.
        </Text>

        {/* Grid container (easier alignment + equal heights) */}
        <div
          className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
          style={{ "--card-accent": "#14b8a6" }}  // set ALL bar colors here; cards can still override
        >
          {/* OffSec — a bit longer to create natural stagger */}
          <Card title={ < > Offensive Security <br/> (Red Teaming) </>} accent="#5e00ff">
            <Text mb={3}>
              Identify critical vulnerabilities before attackers do. We simulate real-world attacks to ensure your
              infrastructure is resilient against breaches.
            </Text>
            <UnorderedList spacing={2}>
              <ListItem>Network Penetration Testing</ListItem>
              <ListItem>Web Application Penetration Testing</ListItem>
              <ListItem>Wi-Fi Penetration Testing</ListItem>
              <ListItem>Vulnerability Scanning</ListItem>
              <ListItem>Mobile Application Testing</ListItem>
            </UnorderedList>
          </Card>

          {/* GRC */}
          <Card title="Management Consulting (GRC)" accent="#00b8ff">
            <Text mb={3}>
              Customised compliance and security strategies aligned to your organisation to prevent costly incidents.
            </Text>
            <UnorderedList spacing={2}>
              <ListItem>vCISO &amp; Hybrid CISO Services</ListItem>
              <ListItem>ISO 27001 Implementation</ListItem>
              <ListItem>ISO 27701 Implementation</ListItem>
              <ListItem>Risk Assessments</ListItem>
              <ListItem>Policy &amp; Procedure Development</ListItem>
            </UnorderedList>
          </Card>

          {/* DataNomad (compact) */}
          <Card title="AI-Driven Compliance (DataNomad)" accent="#00ff9f">
            <Text mb={3}>
              We’ve also built an AI-driven compliance tool that tracks standards and regulations and turns changes into actionable tasks.<br></br> <br></br> Providing clear insights, potential risks and guidance on control implementation.
            </Text>
            <Link href="/datanomad" isExternal>
              <Button mt={2} bg="black" color="#00ff9f" borderRadius="full" _hover={{ bg: "#111" }}>
                Meet DataNomad
              </Button>
            </Link>
          </Card>
        </div>
      </Container>
    </Box>
  );
}
